var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpei = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#303184;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FF9400;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.5,500h-361C31.1,500,0,468.9,0,430.5v-361C0,31.1,31.1,0,69.5,0h361C468.9,0,500,31.1,500,69.5v361 C500,468.9,468.9,500,430.5,500z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.9,219.2c14.1-0.7,27.4-1.8,41.3-2.4c-4-29.2-18.1-44.7-60.8-44.7c-41.9,0-60.2,21.6-62.6,41.4 c-2.7,22.3,14.1,36.6,40.9,44.4c23.2,6.8,42.6,11.5,43.2,22.9c0.7,12.2-13.3,19.1-20.3,19.1c-12.4,0-25.8-13.7-27.5-26.3 c-13.5,1.1-27.5,1.1-40.9,2.2c0,34.1,27.7,52.2,64.5,52.2c34.3,0,68-14.4,68-51.3c0-44.8-48.5-44.8-80.2-55.8 c-11.1-6.1-5.3-19.5,5.1-20.7C97.8,197.6,101.4,209.5,105.9,219.2L105.9,219.2z M238,175.7c27.5,0,47,15.1,47,45.9 c0,28.1-19.4,46.1-47.5,46.1h-35.1v53.9c0,3.7,0,3.7-3.3,3.7h-36.6c-4.6,0-4.6,0-4.6-3.4V182.1c0-6.4,0-6.4,6.4-6.4L238,175.7z  M205.9,239.2c-2.6,0-3.5-1.1-3.5-2.7v-28.9c0-2.1,1.7-3.3,3.3-3.3H221c13.2,2,18.1,9.1,18.1,18.5c0,13.4-11.9,16.5-22.3,16.5 L205.9,239.2L205.9,239.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294.9,179.8c0-1.9,1.3-3.3,2.8-3.3h116.8c2.6-0.1,2.9,0.9,2.9,1.9v26.7c0.1,1.2-0.9,1.8-1.8,1.8h-73.9 c-1.5,0-2.1,1.6-2.1,3.3v18c0,1.9,1.4,3.7,3.7,3.7h65.4l1.5,1.5v25c-0.7,1.1-1.5,2.1-2.2,3.2H342c-1.5,0-2.5,0.9-2.5,2.5v24 c0,1.3,1.6,2.8,3.4,2.8h72.9c1,0,1.5,0.9,1.5,1.5v29.1c0,0.7-0.8,1.4-1.4,1.4H296.1c-0.6,0-1.2-0.6-1.2-1.2L294.9,179.8 L294.9,179.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M480.7,259.2v63.9h-41.6c-0.6,0-1.2-0.6-1.2-1.2v-57.1c0-1.5,1.1-2.4,1.8-2.4h11.9c1.2,0,1.5,1,1.5,1.9V291 c0,3.4,2.8,1.9,4.3,0C465.3,280.4,473,269.8,480.7,259.2L480.7,259.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.2,179.8c0-1.9,1.3-3.3,2.8-3.3h38.2c2.6,0,3.6,1.6,3.6,2.9V234l-23.4-32.7c-0.5-0.7-1.7-0.7-1.7,0.8v23.6 c0,1.3-0.6,3.8-2.5,3.8H438c-0.8,0-1.8-1.9-1.8-2.9L436.2,179.8L436.2,179.8z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpei);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SPEI.fc8b863fc714717271d504877a7d10f0.svg";